import { ChangeDetectionStrategy, Component, inject, Input, output, ViewEncapsulation } from '@angular/core';
import { ObjectTypes } from '@fi-app/shared/types/object-type';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { FiFavoritesService } from '@fi-shared/fi-shared-services/fi-favorites.service';

@Component({
    selector: 'fi-wrapper-table-favorite-toggle-cell',
    template: `
        <button
            mat-icon-button
            class="fi-wrapper-table-favorite-toggle-cell-button"
            (click)="toggleFavoriteStatus($event)"
        >
            <mat-icon [ngClass]="getCurrentIconClass()" />
        </button>
    `,
    styleUrls: ['./fi-wrapper-table-favorite-toggle-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-favorite-toggle-cell' },
    standalone: false,
})
export class FiWrapperTableFavoriteToggleCellComponent extends FiWrapperTableCellBase<boolean> {
    public valueChange = output<boolean>();
    @Input({ required: true }) itemId: number;
    @Input({ required: true }) objectType: ObjectTypes;

    private readonly fiFavoritesService = inject(FiFavoritesService);

    private readonly defaultIconClass = 'far fa-star';
    private readonly favoriteIconClass = 'fas fa-star favorite';

    protected getCurrentIconClass(): string {
        return this.value ? this.favoriteIconClass : this.defaultIconClass;
    }

    protected toggleFavoriteStatus($event: MouseEvent): void {
        $event.stopPropagation();

        const promise = this.value
            ? this.fiFavoritesService.deleteFavorite(this.itemId, this.objectType)
            : this.fiFavoritesService.saveFavorite(this.itemId, this.objectType);

        promise.then(() => {
            this.value = !this.value;
            this.valueChange.emit(this.value);
        });
    }
}
